export const environment = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Bogota",
  code: "CO",
  currency: "COP",
  country_code: "+57",
  gateway: {
    base_url: "https://services.rappi.com",
  },
  currencySymbol: "$",
  country: {
    defaultLocale: "es-CO",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/co/cargo-logos/",
  oAuth: {
    client_id: "C5Ej64OTPM2AV9tpBHwXRMgFB2QIJw0bbPeKDg0v",
    redirect_uri: "hhttps://turbo-wms.rappi.com.co",
    response_type: "code",
    scope: "all",
    flowName: "GeneralOAuthFlow",
  },
  OAuthGateway: "https://www.rappi.com.co/login-legacy",
  userToken: "5543e1d07a2ded5973f80b472f9818be",
  auth0: {
    domain: "turbo-prod.us.auth0.com",
    clientId: "dcvPUE3iXkiFLpqzIpcCtYXCSd70PLAN",
    redirectUri: "https://turbo-wms.rappi.com.co",
  },
  surveyUrl: "https://docs.google.com/forms/d/e/1FAIpQLSdU_1fYNvdKuwuMwFwQxwNZbS11OpX6uf9T0Ezimo7KCUvI5Q/viewform?usp=publish-editor",
};
